(function() {
    'use strict';
    /**
     Generates and enhances button
     @param {Object} buttonDescr Object
     @return {Object} $
     */
    Odigeo.UIElements.createButton = function(buttonDescr) {
        /*
         buttonDescr = {
         text,
         icon,
         iconpos,
         small,
         appearance,
         special,
         alert,
         handler
         }
         */
        var $button = $('<button>', {
            type: 'button',
        });
        var attrs = {};

        $button.html(buttonDescr.text);

        Odigeo._.each(buttonDescr, function(value, key) {
            if (key !== 'text' && key !== 'handler' && key !== 'style') {
                attrs['data-' + key] = value;
            }
        });

        if (buttonDescr.style) {
            $button.addClass(buttonDescr.style);
        }

        if (Odigeo._.isFunction(buttonDescr.handler)) {
            $button.on(Odigeo.Events.tap, buttonDescr.handler);
        }

        $button.attr(attrs);

        return $button;
    };
}());
